<template>
    <div class="col-md-12 mb-4" v-if="user.faqs && user.faqs.length > 0">
        <div class="container-box">
            <div class="container-box-title">{{ translate.account.faqs }}</div>
            <div class="container-box-content" id="profile-page-faq">
                <div class="accordion accordion--faq" v-for="(faq,index) in user.faqs" :key="index">
                    <div class="accordion-title collapsed"
                         data-toggle="collapse"
                         :ref="'profile_faq_' + index"
                         :data-target="'#profile-faq-' + index"
                         :aria-controls="'profile-faq-' + index">{{ faq.question }}
                    </div>
                    <div class="accordion-content collapse" :id="'profile-faq-' + index">
                        <p>{{ faq.answer }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    computed: {
        ...mapState(['translate'])
    },
    props: {
        user: {}
    },
}
</script>
